import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Heart, RefreshCw, Quote } from 'lucide-react';

const MotivacionView = ({ frase, onNuevaFrase }) => {
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">Inspiración Diaria</h2>
        <p className="text-gray-600">Encuentra la motivación que necesitas para escribir</p>
      </div>
      
      {frase ? (
        <div className="space-y-6">
          <Card className="bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 border-rose-200">
            <CardContent className="text-center py-12">
              <Quote className="h-12 w-12 mx-auto text-rose-400 mb-6" />
              <blockquote className="text-2xl font-medium text-gray-800 mb-6 italic leading-relaxed">
                "{frase.frase}"
              </blockquote>
              <cite className="text-lg text-rose-600 font-semibold not-italic">
                — {frase.autor}
              </cite>
            </CardContent>
          </Card>
          
          <div className="text-center">
            <Button onClick={onNuevaFrase} variant="outline" size="lg">
              <RefreshCw className="h-4 w-4 mr-2" />
              Nueva frase inspiradora
            </Button>
          </div>
          
          {/* Consejos adicionales */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Heart className="h-5 w-5 text-red-500" />
                Consejos para mantenerte motivado
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid gap-4 md:grid-cols-2">
                <div className="space-y-3">
                  <h4 className="font-medium text-gray-900">📝 Rutina de escritura</h4>
                  <p className="text-sm text-gray-600">
                    Establece un horario fijo para escribir, aunque sean solo 15 minutos al día.
                  </p>
                </div>
                
                <div className="space-y-3">
                  <h4 className="font-medium text-gray-900">🎯 Objetivos pequeños</h4>
                  <p className="text-sm text-gray-600">
                    Define metas alcanzables: una página, un párrafo, o incluso una oración por día.
                  </p>
                </div>
                
                <div className="space-y-3">
                  <h4 className="font-medium text-gray-900">📚 Lee constantemente</h4>
                  <p className="text-sm text-gray-600">
                    La lectura alimenta tu creatividad y expande tu vocabulario narrativo.
                  </p>
                </div>
                
                <div className="space-y-3">
                  <h4 className="font-medium text-gray-900">✍️ Escribe sin juzgar</h4>
                  <p className="text-sm text-gray-600">
                    Permite que las ideas fluyan sin autocensura. Puedes editar después.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
          
          {/* Recordatorio motivacional */}
          <Card className="bg-amber-50 border-amber-200">
            <CardContent className="text-center py-6">
              <div className="text-4xl mb-2">💪</div>
              <h3 className="text-lg font-semibold text-amber-900 mb-2">
                ¡Recuerda!
              </h3>
              <p className="text-amber-800">
                Cada palabra que escribes te acerca más a convertirte en el escritor que quieres ser. 
                No hay prisa, solo constancia.
              </p>
            </CardContent>
          </Card>
        </div>
      ) : (
        <Card>
          <CardContent className="text-center py-8">
            <Heart className="h-16 w-16 mx-auto text-gray-400 mb-4" />
            <h3 className="text-xl font-semibold mb-2">Cargando inspiración...</h3>
            <p className="text-gray-600">Preparando una frase especial para ti</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default MotivacionView;